import React from 'react';
import { getStaticsBaseUrl } from '@oysterjs/core/config';

// The preview and PDF renderer share the fonts installed on statics.
export const brandWebFontsUrl = (): string => `${getStaticsBaseUrl()}/brand/fonts/catalog.css`;

const LINK_ID = 'brand-web-fonts';

/** Adds the stylesheet to the document once; a second caller finds it already there. */
export const ensureBrandWebFonts = (doc: Document = document): void => {
  if (doc.getElementById(LINK_ID)) {
    return;
  }
  const link = doc.createElement('link');
  link.id = LINK_ID;
  link.rel = 'stylesheet';
  link.href = brandWebFontsUrl();
  doc.head.appendChild(link);
};

/**
 * Loads the catalog for the lifetime of the page. The link is left in place on unmount:
 * the faces are cached by then, and the next page to set type in them is a click away.
 */
export const useBrandWebFonts = (): void => {
  React.useEffect(() => {
    ensureBrandWebFonts();
  }, []);
};
